import axios from 'axios';

const API_URL = process.env.REACT_APP_BASEURL + 'performance-criteria';

export const getAllPerformanceCriteria = (params: { search?: string; limit?: number; skip?: number }) => {
  return axios.get(`${API_URL}/all`, { params });
};

export const createPerformanceCriterion = (payload: any) => {
  return axios.post(`${API_URL}/`, payload);
};

export const updatePerformanceCriterion = (id: string, payload: any) => {
  const body = {
    id,
    ...payload
  };

  return axios.put(`${API_URL}/`, body);
};
export const deletePerformanceCriterion = (id: string) => {
  return axios.delete(`${API_URL}/`, {
    data: { id }
  });
};

/** Create a new PC version from an existing one (existing NOS/QPs keep using the old version). */
export const createNewPCVersion = (id: string, overrides?: Record<string, any>) => {
  return axios.post(`${API_URL}/new-version`, { id, ...overrides });
};
